export const initialState = {
	items: [],
	totalCount: undefined,
	isLoadingItems: false,
	isLoadedItems: false,
	loadItemsErrorMessage: undefined
};

export default { initialState };
